export default "__VITE_ASSET__Cm2M$_ES__"